export default __webpack_public_path__ + "static/media/FS-ABOUT-CARLOSGONZALES-IMAGEN.4d7b6609.png";